/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BlendBridge } from 'blb-types/blendBridge';
import { getConfig } from 'blb-utils/config';
const CLOSING_DATE_COLUMN = 'Eclose.closingDatePipeline';

const baseColumnConfigurations = [
  'Borrower.fullName',
  'Application.propertyAddress.withCityName',
  'Application.propertyAddress.stateCode',
  'Bridge.lenderName',
];

const opsDeskAgentColumnConfigurations = [
  ...baseColumnConfigurations,
  'Eclose.openTasksForOpsDesk',
  'Eclose.closingType',
  'Eclose.closingStatus',
  CLOSING_DATE_COLUMN,
  'Eclose.closingStartPipeline',
];

const settlementAgentColumnConfigurations = [
  ...baseColumnConfigurations,
  'Eclose.openTasksForSettlementAgent',
  'Application.loanType',
  CLOSING_DATE_COLUMN,
];

const attorneyColumnConfigurations = [...baseColumnConfigurations, 'Application.loanType', CLOSING_DATE_COLUMN];

const titleAgentColumnConfigurations = [
  ...baseColumnConfigurations,
  'Application.loanType',
  'Application.loanAmount',
  CLOSING_DATE_COLUMN,
];

const notaryColumnConfigurations = [
  'Notary.closingDate',
  'Notary.signers',
  'Notary.closingType',
  'Application.propertyAddress.withCityName',
  'Application.propertyAddress.stateCode',
  'Bridge.lenderName',
];

const loanProcessorColumnConfigurations = [
  'Application.lenderLoanIdentifier',
  ...baseColumnConfigurations,
  'FastTrack.completionStatus',
  'FastTrack.milestone',
];

export type PipelinePrincipalType = Exclude<BlendBridge.PrincipalType, 'insurance_qc_agent' | 'multi_tenant_tpr'>;

export const getColumnConfigurations = (principalType: PipelinePrincipalType): string[] => {
  const configs: Record<PipelinePrincipalType, string[]> = {
    attorney: attorneyColumnConfigurations,
    loan_processor: loanProcessorColumnConfigurations,
    notary: notaryColumnConfigurations,
    ops_desk_agent: getConfig().enableAutoAssignment
      ? [...opsDeskAgentColumnConfigurations, 'Bridge.opsDeskAgentFullName', 'Bridge.opsDeskAgentNotes']
      : [...opsDeskAgentColumnConfigurations, 'Eclose.opsDeskAgentId'],
    settlement_agent: settlementAgentColumnConfigurations,
    title_agent: titleAgentColumnConfigurations,
  };
  return configs[principalType];
};
